import { connect, MapStateToProps } from "react-redux";

import { IAppState, QAProps } from "@multiweb/types/react";
import { createGetProfileIdsForForm } from "../../selectors";
import { FormItemComponent, FormItemComponentProps } from "../FormItemComponent";

export type FormItemProps = {
    formItemId: number;
} & QAProps;

const createMapStateToProps: () => MapStateToProps<Pick<FormItemComponentProps, "profileIds">, FormItemProps, IAppState> = () => {
    const getProfileIdsForForm = createGetProfileIdsForForm();
    return (state, { formItemId }) => ({
        profileIds: getProfileIdsForForm(state, formItemId),
    });
};

/**
 * Získá profily patřící k formuláři a zobrazí položku formuláře pomocí FormItemComponent.
 */
export const FormItem = connect(createMapStateToProps)(FormItemComponent);
